import { ApiService } from './api/api'
import { processParams } from '@/utils/params'
import type { ProductType } from '@/data/schema/product-type'

export default class ProductTypeService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all product types
	 * @returns Promise
	 */
	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products/types`, { params: processParams(params) })
	}

	/**
	 * Get a product type
	 * @param id String
	 * @param params Record<string, string | string[]
	 * @returns Promise
	 */
	get(id: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products/types/${id}`, { params: processParams(params) })
	}

	create(data: ProductType, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.post(`/products/types`, data, { params: processParams(params) })
	}

	update(
		id: string,
		data: ProductType,
		params?: Record<string, string | string[]>
	): Promise<any> {
		return this.apiService.put(`/products/types/${id}`, data, { params: processParams(params) })
	}

	delete(id: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.delete(`/products/types/${id}`, { params: processParams(params) })
	}
}
